import { useState, useCallback } from 'react';
import { getDepartment } from 'src/components/common/api/getDepartmentAPI';
import { pushErrorFromAPI } from 'src/utilities/notifications';
import { IDepartment } from 'src/utilities/useSearchHooks';

export type UseFetchDepartmentReturnType = {
  isLoading: boolean;
  hasError: boolean;
  department: IDepartment;
  fetchDepartment: (departmentId: string) => Promise<void>;
};

export const useFetchDepartment = (
  corpId: string
): UseFetchDepartmentReturnType => {
  const [isLoading, setIsLoading] = useState(false);
  const [hasError, setHasError] = useState<boolean>();
  const [department, setDepartment] = useState<IDepartment>();

  const fetchDepartment = useCallback(
    async (departmentId: string): Promise<void> => {
      try {
        setIsLoading(true);
        setHasError(false);

        const departmentData = await getDepartment(corpId, departmentId);

        setDepartment(departmentData);
      } catch (err) {
        setHasError(true);
        pushErrorFromAPI(err);
      } finally {
        setIsLoading(false);
      }
    },
    [corpId]
  );

  return {
    isLoading,
    hasError,
    department,
    fetchDepartment,
  };
};
